import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../../../utils/styles';

export const Row = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;
export const InputWrapper = styled(Row)`
  flex: 1;
  display: flex;
  flex-direction: column;
  > div {
    width: 100%;
  }
`;
export const ButtonWrapper = styled(Row)`
  margin-top: 40px;
  flex: 1;
`;
export const LinksWrapper = styled(Row)`
  flex: 0 0 auto;
  margin-top: 20px;
`;
export const ForgotPasswordLink = styled.a`
  font-family: 'Barlow', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #304a9a;
  text-decoration: none;
  cursor: pointer;
`;
export const UseAnotherAccountLink = styled.a`
  font-family: 'Barlow', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #304a9a;
  text-decoration: none;
  cursor: pointer;
`;
export const Centered = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Notification = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${COLORS.red};
`;

export const OrRow = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  margin-bottom: -20px;
  margin-left: 60px;
  margin-right: 60px;
`;

export const Divider = styled.section`
  border-top: 1px solid #ccc;
  flex: 1;
`;

const CenteredOr = styled.section`
  flex: 0 0 auto;
  margin: 0 10px;
`;

export const Or = () => (
  <OrRow>
    <Divider />
    <CenteredOr>OR</CenteredOr>
    <Divider />
  </OrRow>
);

export const LegalText = styled.div`
  margin: 2em auto 0;
  width: 100%;
  max-width: calc(100% - 3em);
  font-size: 0.9rem;
  text-align: center;
  color: #525252;
`;

export const LegalLink = styled.a`
  display: inline-block;
  font-weight: 700;
  color: #525252;
  &:visited {
    color: #525252;
  }
  &:active {
    color: #525252;
  }
  &:hover {
    color: #525252;
  }
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/pages/Login/components.js